{
    "DirectoryList_Column_Description": "Description",
    "DirectoryList_Column_TelephoneNumber": "Telephone number",
    "DirectoryList_Add_Disabled_SelectTelSys": "Select a telephony server to add a directory entry.",
    "DirectoryList_Add_Disabled_NoTelephonyFilter": "Turn off the no telephony server filter to add a directory entry.",
    "NAME": "DirectoryListLanguage"
}
